import React, { useState } from 'react';
import { useAuth } from '../shared/hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const SubscriptionPage = () => {
    const { user, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState('monthly');
    const [selectedPayment, setSelectedPayment] = useState('orange');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [showPaymentForm, setShowPaymentForm] = useState(false);

    const plans = {
        monthly: { price: 3000, label: 'Mensuel' },
        annual: { price: 25000, label: 'Annuel' }
    };

    const handlePlanSelection = (planType, price) => {
        if (!isAuthenticated) {
            // Stocker le plan sélectionné et rediriger vers login
            localStorage.setItem('selectedPlan', JSON.stringify({ planType, price }));
            navigate('/login');
            return;
        }

        if (user?.user_type_id === 1 && !user?.extra?.isAdmin) { // Entreprise
            setSelectedPlan(planType);
            setShowPaymentForm(true);
        } else {
            alert('Les abonnements sont réservés aux entreprises');
        }
    };

    const handlePayment = async () => {
        const paymentData = {
            plan: selectedPlan,
            amount: plans[selectedPlan].price,
            paymentMethod: selectedPayment,
            phoneNumber,
            otpCode: selectedPayment === 'orange' ? otpCode : null
        };

        try {
            // Ici vous intégrerez l'API de paiement
            console.log('Données de paiement:', paymentData);
            alert('Paiement en cours de traitement...');
        } catch (error) {
            console.error('Erreur de paiement:', error);
            alert('Erreur lors du paiement');
        }
    };

    return (
        <div className="container-fluid p-4">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="card border-0 shadow-lg">
                        <div className="card-header text-center py-4" style={{
                            background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 30%, #A855F7 70%, #C084FC 100%)',
                            color: 'white'
                        }}>
                            <h2 className="mb-0">🎯 Abonnement SenOffre</h2>
                            <p className="mb-0 opacity-75">Mettez à niveau votre abonnement</p>
                        </div>

                        <div className="card-body p-5">
                            {!showPaymentForm ? (
                                <>
                                    <div className="text-center mb-5">
                                        <h4>Choisissez votre formule</h4>
                                        <p className="text-muted">Recevez quotidiennement par mail et sms tous les avis d'appels d'offres au Sénégal</p>
                                    </div>

                                    <div className="row g-4">
                                        {/* Plan Mensuel */}
                                        <div className="col-md-6">
                                            <div className="card h-100 border-2 position-relative" style={{
                                                borderColor: selectedPlan === 'monthly' ? '#8B5CF6' : '#e9ecef',
                                                transform: selectedPlan === 'monthly' ? 'scale(1.02)' : 'scale(1)',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                <div className="card-body text-center p-4">
                                                    <div className="badge bg-success mb-3">Populaire</div>
                                                    <h3 className="card-title">Mensuel</h3>
                                                    <div className="display-4 fw-bold text-primary mb-3">
                                                        3000 <small className="fs-6 text-muted">FCFA</small>
                                                    </div>
                                                    <ul className="list-unstyled mb-4">
                                                        <li className="mb-2">✅ Accès complet aux offres</li>
                                                        <li className="mb-2">✅ Notifications SMS & Email</li>
                                                        <li className="mb-2">✅ Support prioritaire</li>
                                                        <li className="mb-2">✅ Statistiques détaillées</li>
                                                    </ul>
                                                    <button 
                                                        className="btn btn-primary btn-lg w-100 rounded-pill"
                                                        onClick={() => handlePlanSelection('monthly', 3000)}
                                                    >
                                                        Choisir Mensuel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Plan Annuel */}
                                        <div className="col-md-6">
                                            <div className="card h-100 border-2 position-relative" style={{
                                                borderColor: selectedPlan === 'annual' ? '#8B5CF6' : '#e9ecef',
                                                transform: selectedPlan === 'annual' ? 'scale(1.02)' : 'scale(1)',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                <div className="card-body text-center p-4">
                                                    <div className="badge bg-warning mb-3">Économie</div>
                                                    <h3 className="card-title">Annuel</h3>
                                                    <div className="display-4 fw-bold text-success mb-3">
                                                        25000 <small className="fs-6 text-muted">FCFA</small>
                                                    </div>
                                                    <div className="text-success mb-3">
                                                        <small>Économisez 16000 FCFA !</small>
                                                    </div>
                                                    <ul className="list-unstyled mb-4">
                                                        <li className="mb-2">✅ Tout du plan mensuel</li>
                                                        <li className="mb-2">✅ 44% d'économie</li>
                                                        <li className="mb-2">✅ Support VIP</li>
                                                        <li className="mb-2">✅ Rapports avancés</li>
                                                    </ul>
                                                    <button 
                                                        className="btn btn-success btn-lg w-100 rounded-pill"
                                                        onClick={() => handlePlanSelection('annual', 25000)}
                                                    >
                                                        Choisir Annuel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="text-center mb-4">
                                        <h4>Détails du paiement</h4>
                                        <p className="text-muted">
                                            Plan sélectionné: <strong>{plans[selectedPlan].label}</strong> - 
                                            <strong className="text-primary"> {plans[selectedPlan].price} FCFA</strong>
                                        </p>
                                    </div>

                                    {/* Méthodes de paiement */}
                                    <div className="row mb-4">
                                        <div className="col-md-6">
                                            <div 
                                                className={`card border-2 cursor-pointer ${selectedPayment === 'orange' ? 'border-warning' : 'border-light'}`}
                                                onClick={() => setSelectedPayment('orange')}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="card-body text-center p-3">
                                                    <img src="/images/orange-money.png" alt="Orange Money" className="mb-2" style={{height: '40px'}} />
                                                    <h6>Orange Money</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div 
                                                className={`card border-2 cursor-pointer ${selectedPayment === 'wave' ? 'border-primary' : 'border-light'}`}
                                                onClick={() => setSelectedPayment('wave')}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="card-body text-center p-3">
                                                    <img src="/images/wave.png" alt="Wave" className="mb-2" style={{height: '40px'}} />
                                                    <h6>Wave</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Formulaire de paiement */}
                                    <div className="row">
                                        <div className="col-md-8 mx-auto">
                                            <div className="mb-3">
                                                <label className="form-label">Numéro de téléphone</label>
                                                <input 
                                                    type="tel" 
                                                    className="form-control form-control-lg"
                                                    placeholder="77 123 45 67"
                                                    value={phoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                />
                                            </div>

                                            {selectedPayment === 'orange' && (
                                                <div className="mb-3">
                                                    <label className="form-label">Code OTP Orange Money</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-lg"
                                                        placeholder="Composez #144#391# puis entrez le code reçu"
                                                        value={otpCode}
                                                        onChange={(e) => setOtpCode(e.target.value)}
                                                    />
                                                    <small className="text-muted">
                                                        Composez <strong>#144#391#</strong> sur votre téléphone pour recevoir le code OTP
                                                    </small>
                                                </div>
                                            )}

                                            <div className="d-grid gap-2">
                                                <button 
                                                    className="btn btn-primary btn-lg"
                                                    onClick={handlePayment}
                                                    disabled={!phoneNumber || (selectedPayment === 'orange' && !otpCode)}
                                                >
                                                    Payer {plans[selectedPlan].price} FCFA
                                                </button>
                                                <button 
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => setShowPaymentForm(false)}
                                                >
                                                    Retour
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPage;
